/**
 * 专题列表页 --- 九游安卓门户
 * @author wuwl@ucweb.com
 * @version 1.0.0 ### 20141117
 * @update: wuwl
 */

  //ajax数据请求
var scrollBottomLoad = require('./scroll_bottom_load');
var nowDate = -1,
  typeParam = $("#param").val() ? JSON.parse($("#param").val()) : {},
  sUrl = $("#param").attr("data-url");

typeParam.isajax=1;
typeParam.beginIndex= typeParam.beginIndex || 0;
typeParam.count=typeParam.count || 6;


var clickMorePageNum = (typeof typeParam.clickMorePageNum === 'number') ? typeParam.clickMorePageNum : 3;//每动态加载几次后显示“点击查看更多”
var numberOfRequests = 0;
function initFunction(){
  $(window).trigger("scroll");
  scrollBottomLoad.setData(typeParam);
}
function endFunction(dataHtml) {
  if (clickMorePageNum===0){
    typeParam.beginIndex = typeParam.beginIndex + typeParam.count;
    return "clickMore";
  }
  var dataHtml=$.trim(dataHtml);
  if (dataHtml == "") {
    return "noMore";
  } else {
    typeParam.beginIndex=typeParam.beginIndex + typeParam.count;
    scrollBottomLoad.setData(typeParam);
  }
  numberOfRequests++;
  if(numberOfRequests % clickMorePageNum == 0){
    return "clickMore";
  }else if(numberOfRequests % clickMorePageNum == 1){
    return "resumeAutoLoad";
  }
}

module.exports = function (successFun,args) {
  var func = function () {};
  var args = args||{};
  if (successFun){
    func = successFun;
  }
  if (clickMorePageNum===0){
    // 如果默认显示点击加载更多，则传入屏蔽滚动加载、屏蔽自动加载一次的参数。
    args.scrollLoad = true;
    args.initScroll = false;
  }
  var defaultArgs = {
    url: sUrl,
    type: "GET",
    data: typeParam,
    loadingTipObjId: "loadingTip",
    loadErrorTipObjId: "errorTip",
    loadMoreTipObjId: "moreBtn",
    noMoreTipObjId: "noMoreTip",
    containerId: "ajaxContainer",
    list_loading: 'list_loading',
    initScroll: true,
    initFun: initFunction,
    endFun: endFunction,
    successFun: func
  }
  Object.assign(defaultArgs,args);
  scrollBottomLoad.init(defaultArgs);
}


// WEBPACK FOOTER //
// ./lib/js/public/ajax_hot_list.js